// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"167":"2d66a947","440":"5ff1fa18","457":"4f97a4b2"}[chunkId] + ".css";
};